import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { AppLinks } from '@blocket/blocket-ui'
import { isAppRoute } from 'paths'
import { fetchFooter } from '../reduxBit/actions'
import Menu from './Menu'
import StyledFooter from './styledFooter'

const FooterWidget = ({ trackFooterNavigation }) => {
  const footerMenuContent = useSelector((state) => state.footerWidget.footerItems)
  const dispatch = useDispatch()

  useEffect(() => dispatch(fetchFooter()), [dispatch])

  if (footerMenuContent && footerMenuContent.length > 0) {
    return (
      <StyledFooter data-cy="footer-navigation">
        <footer className="footer">
          <Menu
            className="footer-menu"
            content={footerMenuContent}
            trackFooterNavigation={trackFooterNavigation}
            isAppRoute={isAppRoute}
          />
          <AppLinks />
        </footer>
      </StyledFooter>
    )
  }
  return null
}

FooterWidget.propTypes = {
  trackFooterNavigation: PropTypes.func,
}

export default FooterWidget
